import { createAction } from '@reduxjs/toolkit';

import { trackError } from 'utils/helpers';
import EcomEngineAPI from 'api/ecom_engine_api';

export const fetchVehicleTypesStarted = createAction(
  'types/fetchVehicleTypesStarted'
);
export const fetchVehicleTypesSucceeded = createAction(
  'types/fetchVehicleTypesSucceeded'
);
export const fetchVehicleTypesFailed = createAction(
  'types/fetchVehicleTypesFailed'
);
export const setVehicleTypes = createAction('types/setVehicleTypes');

export const fetchVehicleTypes = () => (dispatch) => {
  dispatch(fetchVehicleTypesStarted());

  return EcomEngineAPI.utility
    .vehicleTypes()
    .then((response) => {
      dispatch(fetchVehicleTypesSucceeded());
      dispatch(setVehicleTypes(response));
    })
    .catch((error) => {
      trackError(error);
      dispatch(fetchVehicleTypesFailed(error.message));
    });
};
